/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2012,2017
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/

// @import ../../../init/declare
/**
 * This is the common base class of all enumeration types. 
 */
export default class Enum {
	
	_name = null;
	_ordinal = null;
	
	/**
	 * Constructs a new enum. 
	 * @param {String} name - the name of this enum constant.
	 */
	constructor(name) {
		this._name = name;
	}
	
	/**
	 * Returns the name of this enum constant, exactly as declared in its enum declaration.
	 * @return the name of this enum constant
	 */
	name() {
		return this._name;
	}
	
	/**
	 * Returns the ordinal of this enumeration constant.
	 * @return the ordinal of this enumeration constant
	 */
	ordinal() {
		return this._ordinal;
	}
	
	/**
	 * Compares this enum with the specified object for order. Returns a negative integer, zero, or a positive integer as this object is less than, equal to, or greater than the specified object.
	 * @param {Enum} other - the object to be compared.
	 * @return a negative integer, zero, or a positive integer as this object is less than, equal to, or greater than the specified object.
	 */
	compareTo(other) {
		if (this.constructor != other.constructor) {
			throw new Error("ClassCastException: " + this.declaredClass + " is not the same as " + other.declaredClass);
		}
		
		return this._ordinal - other._ordinal;
	}
	
	/**
	 * Returns the name of this enum constant, as contained in the declaration.
	 * @return the name of this enum constant.
	 */
	toString() {
		return this._name;
	}
	
	/**
	 * Returns a hash code for this enum constant.
	 * @return a hash code for this enum constant.
	 */
	hashCode() {
		return 31 * this._ordinal;
	}
	
	/**
	 * Returns true if the specified object is equal to this enum constant.
	 * @param {Enum} obj - the object to be compared for equality with this object.
	 * @return true if the specified object is equal to this enum constant.
	 */
	equals(obj) {
		return this === obj;
	}
	
	/**
	 * Create a new enum literal
	 * @param {String} name - name of the new enum literal
	 * @return a enum literal
	 */
	static newLiteral(name) {
		if (this._enumLiterals === undefined) {
			Object.defineProperty(this, '_enumLiterals', {
				value: [],
				configurable: false,
				writable: false,
				enumerable: false,
			});
		}
		
		var literal = new this(name);
		literal._ordinal = this._enumLiterals.length;
		this._enumLiterals.push(literal);
		return literal;
	}
	
	/**
	 * Returns the enum constant of the specified name.
	 * @param {String} name - the name of the enum constant
	 * @return the enum constant with the specified name
	 */
	static valueOf(name) {
		var literals = this._enumLiterals;
		if (literals) {
			for (var i = 0; i < literals.length; ++i) {
				if (literals[i].name() == name) {
					return literals[i];
				}
			}
		}
		return null;
	}
	
	/**
	 * Return an array of enum constants.
	 * @return an array of enum constants.
	 */
	static values() {
		var literals = this._enumLiterals;
		if (literals) {
			return literals.slice();
		}
		return null;
	}
}


// WEBPACK FOOTER //
// ./src/generated/Enum.js